"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Registry_passwordStorageKey;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registry = exports.RegistryData = void 0;
const MyoCloud_1 = require("./MyoCloud");
const uparsecjs_1 = require("uparsecjs");
const AnnotatedKeyring_1 = require("./AnnotatedKeyring");
const AnnotatedKey_1 = require("./AnnotatedKey");
const MapSerializer_1 = require("./MapSerializer");
const unicrypto_1 = require("unicrypto");
class RegistryData extends MapSerializer_1.CaseObject {
    async scramble(tag) {
        const source = this.source;
        if (!source.tagsSalt)
            throw new Error("registry not properly initialized: no tagsSalt");
        const buffer = uparsecjs_1.concatenateBinary(source.tagsSalt, uparsecjs_1.utf8ToBytes(tag.trim()));
        return await AnnotatedKey_1.hashDigest64Compact("SHA3_256", buffer);
    }
    static createNew(passwordStorageKey) {
        return new RegistryData({
            source: {
                tagsSalt: unicrypto_1.randomBytes(32),
                keyring: new AnnotatedKeyring_1.AnnotatedKeyring().addKeys(passwordStorageKey),
                storageKey: AnnotatedKey_1.AnnotatedKey.createRandomSymmetric()
            }
        });
    }
}
exports.RegistryData = RegistryData;
AnnotatedKeyring_1.AnnotatedKeyring;
MapSerializer_1.MapSerializer.registerCaseObject(RegistryData, "Registry");
class Registry {
    constructor(cloud, passwordStorageKey) {
        this.cloud = cloud;
        this.ready = new uparsecjs_1.CompletablePromise();
        _Registry_passwordStorageKey.set(this, void 0);
        __classPrivateFieldSet(this, _Registry_passwordStorageKey, passwordStorageKey, "f");
        this.initialize();
    }
    async initialize() {
        var _a;
        try {
            this.registryTag = await MyoCloud_1.MyoCloud.simpleScramble("registry1");
            this.backupRegistryTag = await MyoCloud_1.MyoCloud.simpleScramble("registry1_backup");
            console.log("Looking for registry");
            let element = (_a = await this.cloud.elementByUniqueTag(this.registryTag)) !== null && _a !== void 0 ? _a : await this.cloud.elementByUniqueTag(this.backupRegistryTag);
            if (!element)
                element = await this.createRegistryElement();
            console.log("found registry element:" + element);
            const packedRegistry = await __classPrivateFieldGet(this, _Registry_passwordStorageKey, "f").etaDecrypt(element.head);
            // console.log("pr\n", encode64(packedRegistry));
            this.data = await MapSerializer_1.MapSerializer.fromBoss(packedRegistry);
            console.log(">>", this.data);
            // console.log(">>", this.data.source.keyring.allKeys().map(x => x.key.annotationLabel));
            // console.log("!>", BossLoad(MapSerializer.deserializeAny(element.head));
            this.ready.resolve();
        }
        catch (e) {
            this.ready.reject(e);
        }
    }
    async createRegistryElement() {
        if (!__classPrivateFieldGet(this, _Registry_passwordStorageKey, "f"))
            throw new Error("storage key must be set");
        const rd = RegistryData.createNew(__classPrivateFieldGet(this, _Registry_passwordStorageKey, "f"));
        const head = await __classPrivateFieldGet(this, _Registry_passwordStorageKey, "f").etaEncrypt(await MapSerializer_1.MapSerializer.toBoss(rd));
        console.log("creating new registry element");
        let element = await this.cloud.tryCreateElement({ uniqueTag: this.registryTag, head });
        if (element) {
            console.log("registry created, creating registry backup");
            await this.cloud.tryCreateElement({ uniqueTag: this.backupRegistryTag, head });
            return element;
        }
        else {
            console.log("failed to create registry, trying to re-load it");
            element = await this.cloud.elementByUniqueTag(this.registryTag);
            if (!element)
                throw new MyoCloud_1.MyoCloud.Exception("Failed to create or load registry element");
            return element;
        }
    }
    get mainKeyring() {
        if (!this._mainKeyring)
            this._mainKeyring = this.data.source.keyring.clone().addKeys(this.data.source.storageKey);
        return this._mainKeyring;
    }
    get storageKey() {
        return this.data.source.storageKey;
    }
    async scramble(tag) {
        return this.data.scramble(tag);
    }
}
exports.Registry = Registry;
_Registry_passwordStorageKey = new WeakMap();
//# sourceMappingURL=Registry.js.map